module.exports = __webpack_public_path__ + "media/components/home/creator-community/img/k8most-bkg-ca8e307e9fbf7400722a643716ef7c03.jpg";